import { useNavigate } from "@tanstack/react-router";

/**
 * Navegação por caminho, em texto.
 *
 * A árvore de rotas é montada por um laço sobre uma lista (`rota(path, comp)`),
 * então o TanStack não consegue inferir a união literal dos caminhos e o
 * `useNavigate` nasce com o tipo estreito de `"." | ".." | "/"`.
 *
 * Trocar a montagem por rotas declaradas uma a uma daria a inferência de
 * volta, mas custaria a lista legível que hoje serve de índice do produto.
 * Este ajudante concentra a única conversão de tipo em UM lugar, em vez de
 * espalhar cast por cada tela que navega.
 */
export function useIr(): (caminho: string) => void {
  const navegar = useNavigate();
  return (caminho: string) => { void navegar({ to: caminho as never }); };
}
